

  
(function() {
  function enableMegaMenu() {
    document.documentElement.classList.add('mega-menu-ready');
  }

  // Enable menu immediately on DOM ready, don't wait for images
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enableMegaMenu);
  } else {
    enableMegaMenu();
  }
})();



//  document.addEventListener("DOMContentLoaded", function() {
//   // sirf collection page check
//   if (document.body.classList.contains('template-collection')) {

//     const url = new URL(window.location.href);

//     if (!url.searchParams.get('sort_by')) {
//       url.searchParams.set('sort_by', 'best-selling');
//       window.location.href = url.toString();
//     }

//   }
// });
 

 
 // // Run on page load
  // document.addEventListener("DOMContentLoaded", function () {
  //   applyBestValueLabels();

  //   // Listen for variant change
  //   const variantContainer = document.getElementById("variant-selects-template--19919688892655__main");
  //   if (variantContainer) {
  //     variantContainer.addEventListener("change", function () {
  //       setTimeout(applyBestValueLabels, 100); // slight delay in case DOM updates asynchronously
  //     });
  //   }
  // });



$(document).ready(function(){






    // var bodyClass = $('body').attr('class');

    // $('.package_row').each(function () {
    //   var $row = $(this);
    //   var text = $row.find('.package-text1').text().trim().toLowerCase();

    //   // Hide 250 pcs if on template an_ss_new-duplicate-1
    //   if (bodyClass.includes('an_ss_new-duplicate-1') && text === '250 pcs') {
    //     $row.prev('input[type="radio"]').remove(); // Remove radio input
    //     $row.remove(); // Remove the visual block
    //   }

    //   // Hide 500 pcs if on template an_ss_new-duplicate-2
    //   if (bodyClass.includes('an_ss_new-duplicate-2') && text === '500 pcs') {
    //     $row.prev('input[type="radio"]').remove();
    //     $row.remove();
    //   }
    // });






  
   
    $(".custom-visibltiy-menua").click(function () {
        $(".menu-drawer__menu.has-submenu").toggleClass("visibility");
    });

    $(".menu-drawer__close-button").click(function () {
        $(".menu-drawer__menu.has-submenu").removeClass("visibility");
    });

     $(".custom-visibltiy-menua").click(function () {
        $(".menu-drawer").toggleClass("heightps");
    });

    $(".menu-drawer__close-button").click(function () {
        $(".menu-drawer").removeClass("heightps");
    });
    
   


  // Initialize mega menu with CSS classes instead of inline styles for better performance
$('.mega-menu').each(function () {
    const $menu = $(this);
    // Hide all submenus and show first one using classes
    $menu.find('.custom-menu-ps').addClass('menu-hidden').first().removeClass('menu-hidden').addClass('menu-visible');
    // Activate first menu link
    $('.cstm-ancr1').addClass('active-menu-cstm');
});

// Optimized click handler with event delegation and debouncing
let menuClickTimeout;
$('.mega-menu').on('click', '.mega-menu__link', function (e) {
    // Prevent default only if it's a mega-menu__link, not for inner links
    if (!$(this).closest('.custom-menu-ps').length) {
        e.preventDefault();
    }

    // Debounce to prevent rapid clicking issues
    clearTimeout(menuClickTimeout);
    menuClickTimeout = setTimeout(() => {
        const $clickedLink = $(this);
        const $parentMegaMenu = $clickedLink.closest('.mega-menu');
        const $parentLinkPs = $clickedLink.closest('.link-ps');

        // Use class toggling instead of CSS manipulation for better performance
        $parentMegaMenu.find('.custom-menu-ps').removeClass('menu-visible').addClass('menu-hidden');
        $parentMegaMenu.find('.mega-menu__link').removeClass('active-menu-cstm');

        // Show the corresponding submenu
        $parentLinkPs.find('.custom-menu-ps').removeClass('menu-hidden').addClass('menu-visible');
        $clickedLink.addClass('active-menu-cstm');
    }, 50);
});



    
    $('.footer-block__heading.inline-richtext').click(function() {
    $(this).next('.footer-block__details-content').toggleClass('active');

    // Check if .footer-block__details-content has 'active' class, then toggle on heading
    if ($(this).next('.footer-block__details-content').hasClass('active')) {
        $(this).addClass('active');
    } else {
        $(this).removeClass('active');
    }
});


    
        // Slick lives in custom.js, which loads after this file. jQuery's ready
        // can fire before custom.js runs, so wait for slick before initialising.
        function ssInitSliders() {
            if (!$.fn.slick) return false;
            var $marquee = $('.marquee-content').not('.slick-initialized');
            if ($marquee.length) {
                $marquee.slick({
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 0,
                    speed: 3000,
                    cssEase: 'linear',
                    infinite: true,
                    arrows: false,
                    dots: false,
                    variableWidth: true
                });
            }
            var $main = $('.main-image').not('.slick-initialized');
            if ($main.length) {
                $main.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                    fade: false,
                    asNavFor: '.thumbnail-image'
                });
            }
            var $thumbs = $('.thumbnail-image').not('.slick-initialized');
            if ($thumbs.length) {
                $thumbs.slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                    centerMode: false,
                    focusOnSelect: true,
                    asNavFor: '.main-image'
                });
            }
            return true;
        }
        if (!ssInitSliders()) {
            var ssSliderTries = 0;
            var ssSliderTimer = setInterval(function () {
                ssSliderTries++;
                if (ssInitSliders() || ssSliderTries > 100) clearInterval(ssSliderTimer);
            }, 50);
            $(window).on('load', function () { ssInitSliders(); });
        }


                    
    });


document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".price .price-item").forEach(function(priceElement) {
        priceElement.childNodes.forEach(node => {
            if (node.nodeType === 3 && node.textContent.trim().toLowerCase().includes("from")) {
                node.textContent = node.textContent.replace(/from\s*/i, '');
            }
        });
    });





 document.querySelectorAll(".menu-drawer__menu-item.list-menu__item").forEach(function (item) {
        item.addEventListener("click", function () {
            this.classList.toggle("show-icon");
        });
    });

document.querySelectorAll('.mega-menu').forEach(menu => {
  menu.addEventListener('toggle', function() {
    document.body.classList.toggle('menu-open', document.querySelector('.mega-menu[open]') !== null);
  });
});







  
});









document.addEventListener('DOMContentLoaded', function() {
    const accordionHeaders = document.querySelectorAll('.accordion-header');
    
    accordionHeaders.forEach(header => {
      header.addEventListener('click', function() {
        const item = this.parentElement;
        const content = this.nextElementSibling;
        
       
        
        // Toggle current item
        item.classList.toggle('active');
        
      
      });
    });



   


function addCustomClasses() {
  document.querySelectorAll('.an_cable_lug .option__container__size, .an_heatshrink_tubing .option__container__size').forEach(function(el) {
    el.classList.add('option__container__kit', 'size');
  });
}

// Run once on page load
addCustomClasses();

// Observe DOM changes
const targetNode = document.querySelector('.an_cable_lug, .an_heatshrink_tubing');
if (targetNode) {
  const observer = new MutationObserver(() => {
    addCustomClasses();
  });

  observer.observe(targetNode, {
    childList: true,
    subtree: true
  });
}







  
  });



 function openTab(evt, tabName) {
            // Hide all tab contents
            const tabContents = document.getElementsByClassName("tab-content");
            for (let i = 0; i < tabContents.length; i++) {
                tabContents[i].classList.remove("active");
            }
            
            // Remove active class from all tab buttons
            const tabButtons = document.getElementsByClassName("tab-btn");
            for (let i = 0; i < tabButtons.length; i++) {
                tabButtons[i].classList.remove("active");
            }
            
            // Show the current tab and mark its button as active
            document.getElementById(tabName).classList.add("active");
            evt.currentTarget.classList.add("active");
        }





 document.addEventListener('DOMContentLoaded', function() {
    // Handle YouTube video poster click
    document.querySelectorAll('.video-poster').forEach(poster => {
      poster.addEventListener('click', function() {
        const videoWrapper = this.closest('.youtube-video');
        const videoId = videoWrapper.querySelector('.youtube-player').dataset.videoId;
        const autoplay = videoWrapper.querySelector('.youtube-player').dataset.autoplay === 'true';
        const loop = videoWrapper.querySelector('.youtube-player').dataset.loop === 'true';
        const controls = videoWrapper.querySelector('.youtube-player').dataset.controls === 'true';
        
        let params = `autoplay=1&rel=0&modestbranding=1`;
        if (loop) params += '&loop=1&playlist=' + videoId;
        if (!controls) params += '&controls=0';
        
        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', `https://www.youtube.com/embed/${videoId}?${params}`);
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        
        videoWrapper.innerHTML = '';
        videoWrapper.appendChild(iframe);
      });
    });
  });






document.addEventListener("DOMContentLoaded", function () {
    const body = document.body;
    const html = document.documentElement;

    function syncClass() {
        if (body.classList.contains("overflow-hidden-tablet")) {
            html.classList.add("overflow-hidden-tablet");
        } else {
            html.classList.remove("overflow-hidden-tablet");
        }
    }

    // Initial check
    syncClass();

    // Observe class changes on body
    const observer = new MutationObserver(syncClass);

    observer.observe(body, {
        attributes: true,
        attributeFilter: ["class"]
    });
});

